var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-layer-group',{attrs:{"layer-type":"overlay","name":"Lao Administrative"}},[_vm._l((_vm.XhkHpnMainTowns.features),function(feature){return _c('l-marker',{key:feature.properties['name:en'],attrs:{"visible":_vm.displayXhkHpnInfo,"lat-lng":[feature.geometry.coordinates[1], feature.geometry.coordinates[0]],"options":{interactive: true}}},[_c('l-icon',[_c('div',{staticClass:"dot-marker"},[_vm._v(" ◾️ ")])]),_c('l-tooltip',{attrs:{"options":{
        permanent: false,
        direction: 'auto',
        interactive: false,
        className: 'village-label',
        offset: [8, -7]
      }}},[_vm._v(" "+_vm._s(feature.properties['name:en'])+" ")])],1)}),_vm._l((_vm.XhkHpnVteCities.features),function(feature){return _c('l-marker',{key:feature.properties['name:en'],attrs:{"lat-lng":[feature.geometry.coordinates[1], feature.geometry.coordinates[0]],"options":{interactive: false}}},[_c('l-icon',[_c('div',{staticClass:"dot-marker"},[_c('svg',{staticClass:"svg-icon",attrs:{"viewBox":"0 0 20 20"}},[_c('path',{attrs:{"fill":"black","d":"M11.469,10l7.08-7.08c0.406-0.406,0.406-1.064,0-1.469c-0.406-0.406-1.063-0.406-1.469,0L10,8.53l-7.081-7.08 c-0.406-0.406-1.064-0.406-1.469,0c-0.406,0.406-0.406,1.063,0,1.469L8.531,10L1.45,17.081c-0.406,0.406-0.406,1.064,0,1.469 c0.203,0.203,0.469,0.304,0.735,0.304c0.266,0,0.531-0.101,0.735-0.304L10,11.469l7.08,7.081c0.203,0.203,0.469,0.304,0.735,0.304 c0.267,0,0.532-0.101,0.735-0.304c0.406-0.406,0.406-1.064,0-1.469L11.469,10z"}})])])]),_c('l-tooltip',{attrs:{"options":{
        permanent: true,
        direction: 'auto',
        interactive: false,
      }}},[_vm._v(" "+_vm._s(feature.properties['name:en'])+" ")])],1)}),_c('l-geo-json',{attrs:{"name":'XhkHpnPrimaryRoads',"geojson":_vm.XhkHpnPrimaryRoads,"visible":_vm.displayXhkHpnInfo,"options":{
      smoothFactor: _vm.smoothFactor,
      color: _vm.$mapStyleRoadsColor,
      weight: .7,
      interactive: false,
    }}}),_c('l-geo-json',{attrs:{"name":'XhkHpnSecondaryRoads',"visible":_vm.displayXhkHpnInfo,"geojson":_vm.XhkHpnSecondaryRoads,"options":{
      smoothFactor: _vm.smoothFactor,
      color: _vm.$mapStyleRoadsColor,
      weight: .7,
      interactive: false,
    }}}),_c('l-geo-json',{attrs:{"name":'PhaxayLake',"geojson":_vm.PhaxayLake,"visible":_vm.displayXhkHpnInfo,"options":{
      fillColor: _vm.$mapStyleWaterColor,
      opacity: 0,
      fillOpacity: 1,
    }}}),_c('l-geo-json',{attrs:{"name":'LaoPDRDistricts',"geojson":_vm.LaoPDRDistricts,"options":{
      color: _vm.$mapStyleWhite,
      weight: 1,
      onEachFeature: function (feature, layer) { return _vm.onEachFeatureDistrict(feature, layer); },
      interactive: true,
    }}}),_c('l-geo-json',{attrs:{"name":'XhkHpnRivers',"visible":_vm.displayXhkHpnInfo,"geojson":_vm.XhkHpnRivers,"options":{
      smoothFactor: _vm.smoothFactor,
      color: _vm.$mapStyleWaterColor,
      weight: .7,
      interactive: false,
    }}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }